import { observer } from "mobx-react";
import React from "react";
import { StyleSheet } from "react-native";
import { Pressable } from "~/components/V2/Pressable";
import { View } from "~/components/V2/View";
import { styleConstantsV2 } from "~/style/styleConstantsV2";

const S = StyleSheet.create({
  pressable: {
    width: 40,
    height: 24,
    borderRadius: 100,
    borderWidth: 1.5,
  },
  circle: {
    width: 16,
    height: 16,
    borderRadius: 8,
    backgroundColor: styleConstantsV2.colorWhite,
  },
});

export const Toggle = observer(function Toggle({
  value,
  onValueChange,
}: {
  value: boolean | null;
  onValueChange: (value: boolean) => void;
}) {
  return (
    <Pressable
      onPress={() => {
        onValueChange(!value);
      }}
      style={[
        S.pressable,
        {
          backgroundColor: value
            ? styleConstantsV2.colorSuccess
            : styleConstantsV2.colorGrey,
          borderColor: value
            ? styleConstantsV2.colorSuccess
            : styleConstantsV2.colorGrey,
        },
      ]}
    >
      <View
        style={[
          S.circle,
          {
            position: "absolute",
            left: value ? 19 : 3,
            top: 3,
          },
        ]}
      />
    </Pressable>
  );
});
